import React from 'react';
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Box,
} from '@mui/material';

interface UserRoleFormProps {
  role: {
    name: string;
    description: string | null;
    isActive: boolean;
    isSystem?: boolean;
    userCount?: number;
  };
  onChange: (
    field: 'name' | 'description' | 'isActive',
    value: string | boolean
  ) => void;
  isEditMode?: boolean;
}

const UserRoleForm: React.FC<UserRoleFormProps> = ({ role, onChange, isEditMode = false }) => {
  return (
    <Box component="form" noValidate autoComplete="off" sx={{ mt: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Role Name"
            value={role.name}
            onChange={(e) => onChange('name', e.target.value)}
            margin="normal"
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Description"
            value={role.description ?? ''}
            onChange={(e) => onChange('description', e.target.value)}
            margin="normal"
            multiline
            rows={3}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth margin="normal">
            <InputLabel>Status</InputLabel>
            <Select
              value={role.isActive ? 'active' : 'inactive'}
              onChange={(e) => {
                onChange('isActive', e.target.value === 'active');
              }}
              label="Status"
              disabled={isEditMode && role.isSystem}
            >
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="inactive">Inactive</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UserRoleForm;
